'use client';

import { usePathname } from 'next/navigation';
import { PropsWithChildren } from 'react';

import { MenuClientHideConditions } from '../helpers';
import { EventWithPayload } from '@/api/analytics';
import { useAnalytics } from '@/hooks/analytics';

type FooterMenuLinkClientWrapperProps = {
  url: string;
  analyticsEventPayload?: EventWithPayload;
  hideConditions?: MenuClientHideConditions[];
  hideConditionResults: Record<string, boolean>;
};

export const FooterMenuLinkClientWrapper = ({
  url,
  children,
  hideConditions,
  analyticsEventPayload,
  hideConditionResults,
}: PropsWithChildren<FooterMenuLinkClientWrapperProps>) => {
  const pathname = usePathname();
  const { sendEventToAnalytics } = useAnalytics();

  const checkHideConditions = () => {
    return hideConditions?.some((condition) => hideConditionResults[condition]);
  };
  const isHidden = checkHideConditions();
  const isActive = url === pathname;

  const handleClick = () => {
    if (analyticsEventPayload) {
      sendEventToAnalytics(analyticsEventPayload);
    }
  };

  if (isHidden) return null;

  return (
    <li className={isActive ? 'active' : ''} onClick={handleClick}>
      {children}
    </li>
  );
};
